// extracted by mini-css-extract-plugin
export default {"collapse-typography":"ssid_collapse-typography__aSy-8"};